import { render, staticRenderFns } from "./ProductSelection.vue?vue&type=template&id=6043225d&scoped=true"
import script from "./ProductSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSelection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6043225d",
  null
  
)

export default component.exports